module.exports = __webpack_public_path__ + "static/img/windows-02.158f67d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ftp/windows-02.png
// module id = 662
// module chunks = 0